import { withForm } from '@components/ui/form/form';
import { useGetTechnologyDomains, useGetTechnologyUses } from '@queries/technology.query.ts';
import { useStore } from '@tanstack/react-form';
import { mapToSelectOptions } from '@utils/select.util';
import { technologyFormOptions } from './technology-form-options';

export const UsesAndDomainStep = withForm({
  ...technologyFormOptions,
  render: function Render({ form }) {
    const { data: technologyDomains } = useGetTechnologyDomains();
    const { data: technologyUses } = useGetTechnologyUses();

    const primaryDomainId = useStore(form.store, (state) => state.values.primaryDomainId);

    return (
      <form.AppForm>
        <div className="flex w-full flex-col items-start gap-4 py-4">
          <form.AppField name="primaryUseId">
            {(field) => (
              <field.SelectPopoverField
                className="min-w-full"
                contentClassName="min-w-[500px]"
                emptyMessage="No tech use found"
                label="Primary Use"
                onChange={(e) => {
                  const selectedUse = technologyUses?.find((u) => u.id === e.target.value);
                  field.handleChange(e.target.value);

                  if (selectedUse) {
                    form.setFieldValue('primaryUseDescription', selectedUse.description || '');
                  }
                }}
                options={mapToSelectOptions(technologyUses ?? [])}
                placeholder="Select"
                required
                searchPlaceholder="Search tech use..."
              />
            )}
          </form.AppField>

          <form.AppField name="primaryUseDescription">
            {(field) => <field.TextAreaField label="Primary Use Description" />}
          </form.AppField>

          <form.AppField
            name="primaryDomainId"
            listeners={{
              onChange: ({ value: newPrimaryDomainId }) => {
                if (newPrimaryDomainId !== primaryDomainId) {
                  form.setFieldValue('primarySubdomainId', '');
                }
              },
            }}
          >
            {(field) => (
              <field.SelectPopoverField
                className="w-full"
                contentClassName="min-w-[500px]"
                emptyMessage="No tech domain found"
                label="Primary Domain"
                options={mapToSelectOptions(technologyDomains ?? [])}
                placeholder="Select"
                required
                searchPlaceholder="Search tech domain..."
              />
            )}
          </form.AppField>
          <form.AppField name="primarySubdomainId">
            {(field) => (
              <form.Subscribe selector={(state) => ({ primaryDomainId: state.values.primaryDomainId })}>
                {({ primaryDomainId }) => {
                  const selectedDomain = technologyDomains?.find((domain) => domain.id === primaryDomainId);
                  const subdomains = selectedDomain?.subdomains || [];
                  return (
                    <field.SelectPopoverField
                      className="w-full"
                      contentClassName="min-w-[500px]"
                      disabled={!primaryDomainId}
                      emptyMessage="No tech subdomain found"
                      label="Primary Subdomain"
                      options={mapToSelectOptions(subdomains)}
                      placeholder="Select"
                      searchPlaceholder="Search tech subdomain..."
                    />
                  );
                }}
              </form.Subscribe>
            )}
          </form.AppField>
        </div>
      </form.AppForm>
    );
  },
});
